module.exports = __webpack_public_path__ + "static/media/i24Web.e4377a5d.png";